const CustomRequestNewRequestBreadcrumbConstant = [
  {
    title: "Custom Requests",
    link: "/user/custom_requests",
  },
  {
    title: "New Custom Request",
    link: "",
    is_active: true,
  },
];

export default CustomRequestNewRequestBreadcrumbConstant;
